import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { VerifactuConfig } from '@/components/VerifactuConfig';
import { VerifactuEnvios } from '@/components/VerifactuEnvios';
import { AuditoriaContent } from '@/components/AuditoriaContent';
import { Settings, Send, Activity } from 'lucide-react';

export default function VerifactuPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tighter">Verifactu</h1>
        <p className="text-muted-foreground mt-1">
          Configuración y gestión del sistema de integridad de facturas
        </p>
      </div>

      <Tabs defaultValue="config" className="space-y-6">
        <TabsList>
          <TabsTrigger value="config" className="flex items-center gap-2">
            <Settings className="h-4 w-4" />
            Configuración
          </TabsTrigger>
          <TabsTrigger value="envios" className="flex items-center gap-2">
            <Send className="h-4 w-4" />
            Envíos a AEAT
          </TabsTrigger>
          <TabsTrigger value="auditoria" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Auditoría
          </TabsTrigger>
        </TabsList>

        <TabsContent value="config" className="space-y-6">
          <VerifactuConfig />
        </TabsContent>

        <TabsContent value="envios" className="space-y-6">
          <VerifactuEnvios />
        </TabsContent>

        <TabsContent value="auditoria" className="space-y-6">
          <AuditoriaContent />
        </TabsContent>
      </Tabs>
    </div>
  );
}
